/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.UserInfoController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { KeepAliveResponse } from '../models/keep-alive-response';
import { UserInfoResponse } from '../models/user-info-response';

@Injectable()
export class UserInfoApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getUserInfo(spinnerMessage: string = null): Observable<UserInfoResponse> {
        return this.httpClient.get<UserInfoResponse>(`/api/userinfo`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public keepAlive(spinnerMessage: string = null): Observable<KeepAliveResponse> {
        return this.httpClient.get<KeepAliveResponse>(`/api/userinfo/keepAlive`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
